import React, { useEffect} from 'react';
import { connect, useDispatch, useSelector } from "react-redux";
import { Field, reduxForm } from "redux-form";
import {
    renderField,
    required,
    renderToggle,
    renderPass
} from "../../../utils/formValidations.js";
import { Groups, Group, FormFooter } from "../../../components/Form/Form.js"
import { getEgressCredentials } from '../../../actions/actionEgressProvider.js';

let EgressCredentialForm = (props) => {
    const { handleSubmit } = props
    const dispatch = useDispatch()
    const egressCredentials = useSelector(state => state.egress_provider.egressCredentials) || null
    const currentProvider = props.match.params.id

    useEffect(() => {
        if (props.fromUpdate) {
            dispatch(getEgressCredentials())
        }
        props.change('egress_provider_id', currentProvider)
    }, []);

    useEffect(() => {
        if (props.fromUpdate && egressCredentials) {
            const currentCredential = props.match.params.credential_id
            let currentEgressCredential = egressCredentials.find(credential => credential.egress_credential_id === currentCredential);
            props.initialize({
                egress_provider_id: currentEgressCredential.egress_provider_id,
                egress_credential_id: currentEgressCredential.egress_credential_id,
                name: currentEgressCredential.name,
                enabled: currentEgressCredential.enabled,
                username: currentEgressCredential.username,
                password: currentEgressCredential.password,
                tailscale_key: currentEgressCredential.tailscale_key,
                user_id: currentEgressCredential.user_id,
                group_id: currentEgressCredential.group_id,
                image_id: currentEgressCredential.image_id,
            });
        }
    }, [egressCredentials]);

    return (
        <Groups onSubmit={handleSubmit(props.save)} section={props.section}>
            <Group title="general" description="general-description-credential">

                <Field name="enabled"
                    id="enabled"
                    type="checkbox"
                    component={renderToggle}
                />

                <Field name="name"
                    id="name"
                    type="text"
                    component={renderField}
                />

                <Field type="text"
                    name="username"
                    help="kb-26-5"
                    id="username"
                    component={renderField}
                />
                <Field type="text"
                    name="password"
                    help="kb-26-6"
                    id="password"
                    component={renderPass}
                />
                <Field type="text"
                    name="tailscale_key"
                    id="tailscale_key"
                    component={renderPass}
                />
                <Field type="text"
                    name="wireguard_private_key"
                    id="wireguard_private_key"
                    component={renderPass}
                />
                <Field type="text"
                    name="user_id"
                    id="user_id"
                    component={renderField}
                />
                <Field type="text"
                    name="group_id"
                    id="group_id"
                    component={renderField}
                />
                <Field type="text"
                    name="image_id"
                    id="image_id"
                    component={renderField}
                />
            </Group>
            <FormFooter cancel={() => props.history.push(`/update_egress_provider/${currentProvider}?tab=credential`)} />
        </Groups>
    );
}

EgressCredentialForm = reduxForm({
    form: 'EgressCredentialForm'
})(EgressCredentialForm)

EgressCredentialForm = connect(  // eslint-disable-line
    state => ({
        initialValues: { enabled: true },
    })) 
(EgressCredentialForm); 

export default EgressCredentialForm